import { backendAuthenticatedAxios } from '..';

import { AxiosResponse } from 'axios';

const withdrawMethodConsent = async (): Promise<AxiosResponse<void>> => {
  return backendAuthenticatedAxios.post<void>('/repayment/user/withdraw-consent');
};

export default withdrawMethodConsent;
